import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthSignup = Loadable(lazy(() => import('pages/auth/signup')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgetPassword')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/resetPassword')));
const Verification = Loadable(lazy(() => import('pages/auth/verify')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '/',
          element: <AuthLogin />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'signup',
          element: <AuthSignup />
        },
        {
          path: 'code-verification',
          element: <Verification />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        }
      ]
    }
  ]
};

export default LoginRoutes;
